import React from "react";
import styled from "@emotion/styled/macro";
import { COLORS } from "../../../utils/styles/colors";
import { BREAKPOINTS } from "../../../utils/styles/breakpoints";

const Background = styled.div`
  background-color: ${COLORS.customGreenLight};
  padding: 16px 16px;

  ${BREAKPOINTS.MEDIUM} {
    padding: 28px 32px;
  }

  ${BREAKPOINTS.XLARGE} {
    padding: 56px 56px;
    padding-bottom: 28px;
  }
`;

const StyledIframe = styled.iframe`
  width: 100%;
  height: 400px;
  border: 0;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px,
    rgba(0, 0, 0, 0.22) 0px 15px 12px;

  @media (max-width: ${BREAKPOINTS.MEDIUM}) {
    height: 300px;
  }
`;

const StyledLink = styled.a`
  display: block;
  margin-top: 8px;
  color: #1a0dab;
  text-align: center;
  font-weight: 500;
  text-decoration: underline;
`;

export const MapsSection = () => {
  return (
    <Background>
      <StyledIframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7100.860818767592!2d44.873889065497345!3d41.67662224361688!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40440d001914a859%3A0x5cd009062d8f8eed!2zU2FtZ29yaSBQYXJrIFJlc2lkZW5jZSAtIOGDoeGDkOGDm-GDkuGDneGDoOGDmCDhg57hg5Dhg6Dhg5kg4YOg4YOU4YOW4YOY4YOT4YOU4YOc4YOh!5e0!3m2!1sen!2sge!4v1753101334962!5m2!1sen!2sge"
        allowFullScreen
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Samgori Park Residence Map"
      />
    </Background>
  );
};
